import { render, staticRenderFns } from "./ChanelListSvg.vue?vue&type=template&id=66d03b84&scoped=true"
import script from "./ChanelListSvg.vue?vue&type=script&lang=js"
export * from "./ChanelListSvg.vue?vue&type=script&lang=js"
import style0 from "./ChanelListSvg.vue?vue&type=style&index=0&id=66d03b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d03b84",
  null
  
)

export default component.exports